<template>
    <div class="row">
        <div class="col-md-12">
            <div class="alert_alertContainer alert" :class="noticeClass" role="alert">
                <button v-if="dismissable" type="button" data-bs-dismiss="alert" data-target="alert" aria-label="close" class="btn-close">&times;</button>
                <div v-html="notice"></div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: 'np-notice',
        props: {
            notice: {
                default: ''
            },
          dismissable:{
                type: Boolean,
            },
            noticeClass: {
                default: 'alert-info'
            }
        }
    }
</script>
